var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"room"}},[_c('img',{staticClass:"roomBackground",attrs:{"src":_vm.roomData[_vm.currentRoomNumber].roomimage}}),_c('GameView',{attrs:{"currentRoomData":[{room:_vm.roomData[_vm.currentRoomNumber]}]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }